<template>
  <v-container v-if="!isMobile">
    <nav>
      <v-app-bar app height="80">
        <v-toolbar-title>
          <v-breadcrumbs :items="items" large></v-breadcrumbs>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-md-date-range-picker :presets="presets" opens="right" @change="updateData" class="mr-2">
          <v-card class="pa-2" slot="input" style="outline:1px solid grey;">
            <v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate($store.state.dateTime1) }} -{{ formatDate($store.state.dateTime2) }}</span>
          </v-card>
        </v-md-date-range-picker>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn :loading="loading5" :disabled="loading5" :color="!timer ? 'red' : 'green'" :class="!timer ? 'ma-1 white--text' : 'ma-1 white--text'" @click="(timer = !timer), (loader = 'loading5')" fab small v-bind="attrs" v-on="on">
              <v-icon dark>
                {{ !timer ? "mdi-play" : "mdi-pause" }}
              </v-icon>
            </v-btn>
          </template>
          <span> {{ !timer ? "Enable Auto Refresh Page" : "Disable Auto Refresh Page" }}</span>
        </v-tooltip>
      </v-app-bar>
    </nav>

    <v-row>
      <v-col v-if="loading">
        <v-container style="height: 200px;">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              Getting your chart
            </v-col>
            <v-col cols="6">
              <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col v-else>
        <apexchart width="800" height="400" type="line" :options="waterChart" :series="waterSeries"></apexchart>
      </v-col>

      <v-col>
        <p class="mx-auto text-center" style="font-size:12px;color:black;">Water Flow/min</p>
        <v-row dense>
          <v-col>
            <v-card class="mx-auto text-center" color="cyan" dark max-width="200" max-height="200">
              <v-card-text>
                <div style="font-size:12px;color:black;">
                  Location Unit
                </div>
                <div style="font-size:15px;color:black;" v-if="waterFlow.length == 0">
                  No Data
                </div>
                <div style="font-size:15px;color:black;" v-else>
                  {{ location[0] }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:black;">
                  Recently
                </div>
                <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:black;" v-else>{{ value.slice(-1)[0].toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mx-auto text-center" color="grey lighten-1" dark max-width="200" max-height="100">
              <div style="font-size:12px;color:black;">
                Peak
              </div>
              <div style="font-size:14.5px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:black;" v-else>{{ Math.max(...value).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card>
            <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100">
              <div style="font-size:12px;color:black;">
                Min
              </div>
              <div style="font-size:14.5px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:black;" v-else>{{ Math.min(...value).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:black;">
                  Total Query Period
                </div>
                <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:black;" v-else>{{ value.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

  <div v-else>
    <div class="mt-1 pa-1" justify="center" align="center">
      <div class="pa-1">
        <v-card style="text-align:left; display:flex; justify-content:space-between;">
          <v-md-date-range-picker :presets="presets" opens="left" @change="updateData">
            <v-card class="pa-3" slot="input" flat>
              <v-icon color="red darken-2"> mdi-clock-outline </v-icon><span style="font-size: 12px; margin-left: 5px;">{{ formatDate($store.state.dateTime1) }} - {{ formatDate($store.state.dateTime2) }}</span>
            </v-card>
          </v-md-date-range-picker>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn :loading="loading5" :disabled="loading5" :color="!timer ? 'red' : 'green'" :class="!timer ? 'ma-1 white--text' : 'ma-1 white--text'" @click="(timer = !timer), (loader = 'loading5')" fab small v-bind="attrs" v-on="on">
                <v-icon dark>
                  {{ !timer ? "mdi-play" : "mdi-pause" }}
                </v-icon>
              </v-btn>
            </template>
            <span> {{ !timer ? "Enable Auto Refresh Page" : "Disable Auto Refresh Page" }}</span>
          </v-tooltip>
        </v-card>
      </div>
    </div>

    <v-container>
      <div class="mt-5">
        <div v-if="loading">
          <v-container style="height: 200px;">
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12">
                <span style="font-size:12px">Getting your chart</span>
              </v-col>
              <v-col cols="6">
                <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <div v-else>
          <v-card class="pa-1 pt-10 pb-10">
            <div class="mb-5" style="text-align:center;">
              <h3 style="color:grey;">{{ location[0] }}</h3>
            </div>
            <apexchart height="200" type="line" :options="waterChart" :series="waterSeries"></apexchart>

            <div class="mt-5">
              <div style="display: flex; justify-content:center; margin-bottom: 10px;">
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px; color: black;" width="35vw">Recently</v-btn>
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px; color: black;" width="35vw" v-if="waterFlow.length == 0">No Data</v-btn>
                <v-btn flat color="white" style="font-size: 12px" width="35vw" v-else>{{ value.slice(-1)[0].toFixed(2) }}<span style="font-size:12px;color:black;">L</span></v-btn>
              </div>
            </div>
            <div class="mt-5">
              <div style="display: flex; justify-content:center; margin-bottom: 10px;">
                <v-btn flat color="grey lighten-1" style="font-size: 10px; margin-right: 5px; color: black;" width="35vw">Peak</v-btn>
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px; color: black;" width="35vw" v-if="waterFlow.length == 0">No Data</v-btn>
                <v-btn flat color="white" style="font-size: 12px" width="35vw" v-else>{{ Math.max(...value).toFixed(2) }}<span style="font-size:12px;color:black;">L</span></v-btn>
              </div>
            </div>
            <div class="mt-5">
              <div style="display: flex; justify-content:center; margin-bottom: 10px;">
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px; color: black;" width="35vw">Min</v-btn>
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px; color: black;" width="35vw" v-if="waterFlow.length == 0">No Data</v-btn>
                <v-btn flat color="white" style="font-size: 12px" width="35vw" v-else>{{ Math.min(...value).toFixed(2) }}<span style="font-size:12px;color:black;">L</span></v-btn>
              </div>
            </div>
            <div class="mt-5">
              <div style="display: flex; justify-content:center; margin-bottom: 10px;">
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px; color: black;" width="35vw">Total Query Period</v-btn>
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px; color: black;" width="35vw" v-if="waterFlow.length == 0">No Data</v-btn>
                <v-btn flat color="white" style="font-size: 12px" width="35vw" v-else>{{ value.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:12px;color:black;">L</span></v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
  import Vue from "vue";
  import axios from "axios";
  import moment from "moment";
  import VueApexCharts from "vue-apexcharts";

  Vue.component("apexchart", VueApexCharts);

  export default {
    data: () => ({
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Water Flow",
          disabled: true,
          href: "",
        },
        {
          text: "Usage By Location",
          disabled: false,
          href: "/usage-by-location-water-flow",
        },
        {
          text: "Details",
          disabled: true,
          href: "",
        },
      ],
      // values1: moment().subtract(24, "hour"),
      // values2: moment().endOf("day"),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment().endOf("day")],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [moment().subtract(6, "day"), moment().endOf("day")],
        },
        {
          label: "Last Week",
          range: [
            moment()
              .subtract(13, "day")
              .startOf("day"),
            moment()
              .subtract(7, "day")
              .endOf("day"),
          ],
        },
        {
          label: "This Month",
          range: [
            moment()
              .startOf("month")
              .startOf("day"),
            moment().endOf("month"),
          ],
        },
        {
          label: "Last Month",
          range: [
            moment()
              .subtract(1, "month")
              .startOf("month"),
            moment()
              .subtract(1, "month")
              .endOf("month"),
          ],
        },
      ],
      timer: true,
      loader: null,
      loading5: false,
      isMobile: true,
      loading: true,
      waterFlow: [],
      value: [],
      location: [],
      waterChart: {
        chart: {
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          tooltip: {
            enabled: false,
          },
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "top",
        },
        yaxis: {
          axisTicks: {
            show: true,
          },
          labels: {
            formatter: (val) => {
              return val.toFixed(2) + "L";
            },
          },
        },
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
      },
      waterSeries: [
        {
          data: [],
        },
      ],
    }),
    mounted() {
      this.loadsWaterFlow();
      this.intervalFetchData();
      this.onResize();
      window.addEventListener("resize", this.onResize, { passive: true });
    },
    methods: {
      intervalFetchData: function() {
        setInterval(() => {
          if (this.timer == true) {
            this.loadsWaterFlow();
          }
        }, 60000);
      },
      onResize() {
        this.isMobile = window.innerWidth < 700;
      },
      formatDate(value) {
        return moment(value).format("D MMM YYYY, h:mm:ss a");
      },
      loadsWaterFlow: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/waterflow3/" + this.$route.params.id + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.waterFlow = res.data;
            this.value = res.data.map((value) => value.value);
            this.location = res.data.map((loc) => loc.location);

            let water = this.waterFlow.map((e) => {
              return {
                x: e.timestamp,
                y: e.value,
              };
            });

            this.waterSeries = [
              {
                name: "Water Flow/min",
                data: water,
              },
            ];
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loading = false));
      },
      updateData(values) {
        this.values1 = values[0];
        this.values2 = values[1];
        this.$store.commit("setDateTime1", this.values1);
        this.$store.commit("setDateTime2", this.values2);
        this.loadsWaterFlow();
        this.loading = true;
      },
    },
    beforeDestroy() {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", this.onResize, { passive: true });
      }
    },
    watch: {
      loader() {
        const l = this.loader;
        this[l] = !this[l];

        setTimeout(() => (this[l] = false), 500);

        this.loader = null;
      },
    },
  };
</script>

<style scoped>
  .pick {
    position: sticky;
    top: 52px;
    z-index: 100;
  }
</style>
